import React from 'react';
import { Modal } from 'react-bootstrap';
import { PromptType } from '../../constants/parameters';
import { ModalFragmentProps } from '../../constants/types';
import useAccountSecurityPromptContext from '../../hooks/useAccountSecurityPromptContext';
import { AccountSecurityPromptActionType } from '../../store/action';
import ModalState from '../../store/modalState';
import { FooterButtonConfig, FragmentModalFooter } from './fragments/modalFooter';
import { FragmentModalHeader, HeaderButtonType } from './fragments/modalHeader';

/**
 * The dismiss forever confirmation page of either flow (logic switched based
 * on flow type).
 */
const ModalDismissConfirmation: React.FC<ModalFragmentProps> = ({
  closeModal
}: ModalFragmentProps) => {
  const {
    state: { promptType, resources },
    dispatch
  } = useAccountSecurityPromptContext();

  /*
   * Event Handlers
   */

  const dismissForever = () => {
    dispatch({ type: AccountSecurityPromptActionType.DISMISS_FOREVER });
  };

  const abortAction = () => {
    dispatch({
      type: AccountSecurityPromptActionType.SET_MODAL_STATE,
      modalState:
        promptType === PromptType.ADD_EMAIL
          ? ModalState.ADD_EMAIL_FORM
          : ModalState.CHANGE_PASSWORD_INTRO
    });
  };

  /*
   * Render Properties
   */

  const bodyMessage =
    promptType === PromptType.ADD_EMAIL
      ? resources.Description.AreYouSureDismissForeverAddEmail
      : resources.Description.AreYouSureDismissForeverChangePassword;

  const confirmActionText =
    promptType === PromptType.ADD_EMAIL
      ? resources.Action.ConfirmDismissForeverAddEmail
      : resources.Action.ConfirmDismissForeverChangePassword;

  const abortActionText =
    promptType === PromptType.ADD_EMAIL
      ? resources.Action.AbortDismissForeverAddEmail
      : resources.Action.AbortDismissForeverChangePassword;

  const positiveButton: FooterButtonConfig = {
    // Show a spinner as the button content when a request is in flight.
    content: abortActionText,
    label: abortActionText,
    enabled: true,
    action: abortAction
  };

  const negativeButton: FooterButtonConfig = {
    // Show a spinner as the button content when a request is in flight.
    content: confirmActionText,
    label: confirmActionText,
    enabled: true,
    action: dismissForever
  };

  /*
   * Component Markup
   */

  return (
    <React.Fragment>
      <FragmentModalHeader
        headerText={resources.Header.AreYouSure}
        buttonType={HeaderButtonType.HIDDEN}
        buttonAction={closeModal}
        buttonEnabled
        headerInfo={null}
      />
      <Modal.Body>
        <div className='modal-shield' />
        <p>{bodyMessage}</p>
      </Modal.Body>
      <FragmentModalFooter positiveButton={positiveButton} negativeButton={negativeButton} />
    </React.Fragment>
  );
};

export default ModalDismissConfirmation;
